import { useState } from "react";
import { Button, Flex, Modal, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export const BatchModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(() => {
    const modalBatchOpened = sessionStorage.getItem("modalBatchOpened");
    if (!modalBatchOpened) return true;
  });

  const handleOk = () => {
    sessionStorage.setItem("modalBatchOpened", "false");
    setIsModalOpen(false);
  };

  return (
    <Modal
      title={
        <Flex gap={8} align="center">
          <ExclamationCircleOutlined style={{ color: "#40A9FF" }} />
          <p>Atenção</p>
        </Flex>
      }
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={
        <Button type="primary" onClick={handleOk}>
          Ciente
        </Button>
      }
    >
      <Typography.Text>
        Identificamos que você pode ter CPF’s aptos para{" "}
        <strong>Aumento Salarial</strong>. Acesse o produto{" "}
        <strong>Digitação em Lote</strong> para conferir e dar continuidade ao
        processo.
      </Typography.Text>
    </Modal>
  );
};
